const GoogleDetailPage = () => {
    return (
        <div>
            It's a very common experience for developers to be on a team that gets annoyed with tools like Jira
            and starts using Google Docs or Sheets to manage their work. This works for a while, but as the
            the backlog grows it becomes difficult to keep track of everything.
            <br /><br />
            Even for a single developer without a backlog, Uclusion is immediately better because you can 
            easily track your in progress tasks. Click in progress on a task and you are prompted to remove 
            in progress from any existing in progress tasks. Plus in progress tasks show in the job progress visualization
            and the navigation button takes you directly to what is in progress.
        </div>
    );
};

export default GoogleDetailPage;